import React from "react";

/**
 * MAHAKAIN mark — interlaced threads forming an "M" knot.
 * Represents the convergence of industrial strength and silk craft.
 */
export const LogoMark = ({ className = "", size = 34 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <rect x="2" y="2" width="44" height="44" stroke="currentColor" strokeWidth="1.2" opacity="0.35" />
    <path
      d="M11 35V14L24 27L37 14V35"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="miter"
    />
    <path d="M11 14L24 20L37 14" stroke="currentColor" strokeWidth="1" opacity="0.6" />
    <path d="M11 21L24 27L37 21" stroke="currentColor" strokeWidth="1" opacity="0.45" />
    <circle cx="24" cy="27" r="1.6" fill="currentColor" />
  </svg>
);

export const Logo = ({ className = "", onClick }) => {
  return (
    <button
      onClick={onClick}
      data-testid="brand-logo"
      className={`group flex items-center gap-3 ${className}`}
    >
      <span className="text-gold transition-transform duration-500 group-hover:rotate-[8deg]">
        <LogoMark />
      </span>
      <span className="flex flex-col items-start leading-none">
        <span className="font-heading text-2xl font-medium tracking-tight text-foreground">
          MAHAKAIN
        </span>
        <span className="font-body text-[9px] font-medium uppercase tracking-luxe text-muted-foreground">
          Sutera Nirmala
        </span>
      </span>
    </button>
  );
};

export default Logo;
